import { useState } from 'react';
import { toast } from 'sonner';
import { api, formatApiErrorDetail } from '@/lib/api';
import { PageHero } from '@/components/Cards';
import { Reveal } from '@/components/Reveal';
import { useContent } from '@/lib/useContent';

const FIELD = 'w-full border border-brayo-line bg-white px-4 py-3.5 text-base md:text-sm text-brayo-charcoal placeholder:text-brayo-dim focus:border-brayo-blue focus:outline-none transition-colors';

export default function Contact() {
  const content = useContent();
  const [form, setForm] = useState({ name: '', email: '', department: 'A&R / Demos', artist_name: '', genre: '', link: '', message: '' });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post('/submissions', form);
      toast.success('Submission received. The label will be in touch.');
      setForm({ name: '', email: '', department: 'A&R / Demos', artist_name: '', genre: '', link: '', message: '' });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <PageHero overline={content.contact_overline || 'Contact'} title={content.contact_title || 'A&R / Demos'} />

      <section data-testid="contact-page" className="mx-auto max-w-[900px] px-5 py-16 md:px-10 md:py-24">
        <Reveal>
          <form data-testid="contact-form" onSubmit={submit} className="space-y-5">
            <div className="grid gap-5 sm:grid-cols-2">
              <input data-testid="contact-name-input" required value={form.name} onChange={set('name')} placeholder="Your name" className={FIELD} />
              <input data-testid="contact-email-input" required type="email" value={form.email} onChange={set('email')} placeholder="Email address" className={FIELD} />
            </div>
            <div className="grid gap-5 sm:grid-cols-2">
              <input data-testid="contact-artist-input" value={form.artist_name} onChange={set('artist_name')} placeholder="Artist / project name" className={FIELD} />
              <input data-testid="contact-genre-input" value={form.genre} onChange={set('genre')} placeholder="Genre" className={FIELD} />
            </div>
            <input data-testid="contact-link-input" value={form.link} onChange={set('link')} placeholder="Streaming link to your music (Spotify, SoundCloud…)" className={FIELD} />
            <textarea data-testid="contact-message-input" value={form.message} onChange={set('message')} placeholder="Tell us about the music" rows={6} className={`${FIELD} resize-none`} />
            <button
              data-testid="contact-submit-btn"
              type="submit"
              disabled={sending}
              className="arrow-slide meta-label flex items-center gap-3 bg-brayo-blue px-8 py-4 text-white transition-colors hover:bg-brayo-charcoal disabled:opacity-50"
            >
              {sending ? 'Sending…' : 'Send Submission'}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
            </button>
          </form>
        </Reveal>
      </section>
    </>
  );
}